import { render } from "./MyTeamDetail.vue?vue&type=template&id=25ffb353&scoped=true"
import script from "./MyTeamDetail.vue?vue&type=script&lang=js"
export * from "./MyTeamDetail.vue?vue&type=script&lang=js"

import "./MyTeamDetail.vue?vue&type=style&index=0&id=25ffb353&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ffb353"]])

export default __exports__